import React, { useState } from 'react';
import ReceiptIcon from '@mui/icons-material/Receipt';

import HoverActionField from '~/components/HoverActionField';
import type { ExposureModel } from '~/components/types/exposure-types';

import InvoiceDamageAssessmentCard from './InvoiceDamageAssessmentCard';

interface Props {
  exposure: ExposureModel;
}

const InvoiceDamageAssessmentContainer: React.FC<Props> = ({ exposure }) => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  return (
    <>
      <HoverActionField icon={ReceiptIcon} onAction={() => setIsDialogOpen(true)}>
        <em>View</em>
      </HoverActionField>
      {isDialogOpen && (
        <InvoiceDamageAssessmentCard
          exposure={exposure}
          cardDialogProps={{
            isDialog: true,
            open: isDialogOpen,
            closeOnBackdropClick: true,
            onClose: () => setIsDialogOpen(false),
          }}
        />
      )}
    </>
  );
};

export default InvoiceDamageAssessmentContainer;
